// extracted by mini-css-extract-plugin
export var createdDate = "_o3-1";
export var divider = "_o3-2";
export var headerDivider = "_o3-3";
export var messagesCard = "_o3-0";
export var messagesContainer = "_o3-6";
export var messagesContainerWrapper = "_o3-4";
export var showLeftPanelButton = "_o3-8";
export var topButtons = "_o3-7";
export var withPadding = "_o3-5";